import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Fabric} from '../../../Models/Fabric';
import {ActivatedRoute, Router} from '@angular/router';
import {FabricService} from '../../../Services/fabric.service';
import {Helper} from '../../../../helpers/helper.service';
import {FabricColor} from '../../../Models/FabricColor';
import {Grid} from '../../../../shared/Models/grid';
import {TranslateService} from '@ngx-translate/core';
import {FabricColorService} from '../../../Services/fabric-color.service';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {environment} from '../../../../../environments/environment';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {NgForm} from '@angular/forms';

const baseUri = environment.apiUrl;
const URL = baseUri + '/backoffice/file_manager?bupload=FabricColor.image&quality=75';

@Component({
  selector: 'app-fabric-view',
  templateUrl: './fabric-view.component.html',
  styleUrls: ['./fabric-view.component.scss']
})
export class FabricViewComponent implements OnInit {
  public addFileItem = false;
  public isUploading = false;
  public isNotAdd = false;
  public fabric: Fabric = new Fabric();
  public fabricColors: FabricColor[] = [];
  public fabricColor = new FabricColor();
  public fabricId: number;
  public grid: Grid;
  public baseURL = environment.absolutePath;
  private target: any;
  public isEdit = false;
  public archive: boolean = false;
  public color: string;
  public fabricColorId: number;
  public fabricColorImg = '';
  @ViewChild('addColorToFabricModal', {static: true}) addColorToFabricModal = null;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;
  @ViewChild('readdModal', {static: false}) readdModal = null;
  @ViewChild('addColorForm', {static: false}) addColorForm: NgForm;
  @ViewChild('uploadEl', {static: false}) uploadElRef: ElementRef;
  public uploader: FileUploader = new FileUploader({
    itemAlias: 'image',
    url: URL,
    authToken: this.auth.getBearerHeader(),
  });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fabricService: FabricService,
    private fabricColorService: FabricColorService,
    private translateService: TranslateService,
    private auth: AuthenticationService,
    private helper: Helper
  ) {
  }

  ngOnInit() {

    this.uploader.onAfterAddingFile = (item => {
      if (this.target) {
        this.target.value = '';
      }
      item.withCredentials = false;
      this.fabricColorImg = item.file.name;
    });
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.fabricId = params['fabricId'];
        this.getFabricInformation();
      }
    });
  }

  getFabricInformation() {
    this.fabricService.getFabric(this.fabricId).subscribe(resp => {
      this.fabric = resp;
      this.fabricColors = resp.fabricColors;
      if (this.fabric.status === true) {
        this.fabric.status = this.translateService.instant('global.active');
      } else {
        this.fabric.status = this.translateService.instant('global.inactive');
      }
    });
  }

  getColors() {
    this.fabricService.getFabricColor(this.fabricId).subscribe(resp => {
      this.fabricColors = resp.fabricColors;
    });
    this.archive = false;
  }

  getDeleteColors() {
    this.fabricService.getFabricDeleteColor(this.fabricId).subscribe(resp => {
      this.fabricColors = resp;
    });
    this.archive = true;
  }

  addColor() {
    const id = (this.fabricColor.id) ? JSON.parse(JSON.stringify(this.fabricColor.id)) : null;
    if (id) {
      delete this.fabricColor.id;
      delete this.fabricColor.position;
      delete this.fabricColor.parentPosition;
    }
    new Promise((resolve) => {
      if (this.uploader.queue.length === 0) {
        return resolve(true);
      }
      this.uploadFile(() => {
        resolve(true);
      });
    }).then(() => {
      if (this.fabricColor.image) {
        if (this.fabricColor.image['id']) {
          this.fabricColor.image = this.fabricColor.image['id'];
        }
      }
      this.fabricColorService.manageFabricColor(this.fabricColor, this.isEdit, id).subscribe(res => {
        this.addColorToFabricModal.hide();
        this.addColorForm.resetForm();
        this.fabricColor = new FabricColor();
        this.uploader.clearQueue();
        this.uploadElRef.nativeElement.value = '';
        this.getFabricInformation();
      });
    });
  }

  softDeleteColor() {
    this.deleteColorFromFabric();
  }

  deleteColorFromFabric() {
    this.fabricColorService.softDeleteFabricColor(this.fabricColorId).subscribe((res) => {
      this.getColors();
      this.deleteModal.hide();
    });
  }

  readd() {
    this.fabricColorService.softReAddFabricColor(this.fabricColorId).subscribe((res) => {
      this.getDeleteColors();
      this.readdModal.hide();
    });
  }

  openModalForAddColor() {
    if (this.fabricColor.status == null) {
      this.fabricColor.status = true;
    }
    this.fabricColor.fabric = this.fabricId;
    this.addColorToFabricModal.show();
    this.isEdit = false;
  }

  openModalForEditColor(color) {
    this.fabricColor = JSON.parse(JSON.stringify(color));
    this.fabricColor.fabric = this.fabricId;
    if (this.fabricColor.image && this.fabricColor.image.filename) {
      this.fabricColorImg = this.fabricColor.image.filename;
    }
    this.fabricColorId = color.id;
    this.isEdit = true;
    this.addColorToFabricModal.show();
  }

  openModalForDeleteColor(color) {
    this.deleteModal.show();
    this.fabricColorId = color.id;
    this.color = color.name;
  }

  getFabric() {
    return Fabric;
  }

  uploadFile(cb) {
    this.addFileItem = true;
    this.isUploading = true;
    this.uploader.uploadAll();
    this.uploader.onErrorItem = (item: FileItem, response, status: number, headers: ParsedResponseHeaders) => {
      this.isUploading = false;
      this.uploader.clearQueue();
      this.uploadElRef.nativeElement.value = '';
      const res = JSON.parse(response);
      this.helper.popMessageDialog(res.title, res.errors);
    };
    this.uploader.onSuccessItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (response) {
        if (this.fabricColor.image && this.fabricColor.image['id']) {
          this.fabricColorService.removeImage(this.fabricColor.image['id'], this.fabricColorId).subscribe(() => {
            this.addFileItem = false;
            this.isUploading = false;
            this.isNotAdd = false;
            this.uploader.clearQueue();
            this.uploadElRef.nativeElement.value = '';
            const res = JSON.parse(response);
            this.fabricColor.image = res.id;
            cb();
          });
        } else {
          this.addFileItem = false;
          this.isUploading = false;
          this.isNotAdd = false;
          this.uploader.clearQueue();
          this.uploadElRef.nativeElement.value = '';
          const res = JSON.parse(response);
          this.fabricColor.image = res.id;
          cb();
        }
      }
    };
  }

  setDetailForReadd(color) {
    this.readdModal.show();
    this.color = color.name.bold();
    this.fabricColorId = color.id;
  }

  setParentPosition(id, positionNumber) {
    const position = {position: positionNumber};
    this.fabricService.setParentPosition(position, id).subscribe(
      (res) => {
        this.getColors();
      }
    );
  }

  closeFabricColorModal() {
    this.addColorToFabricModal.hide();
    this.addColorForm.resetForm();
    this.fabricColor.image = null;
    this.fabricColorImg = null;
    this.isUploading = false;
    this.uploader.clearQueue();
    this.uploadElRef.nativeElement.value = '';
  }

  changeImage(event) {
    this.isUploading = false;
    this.uploader.clearQueue();
    this.fabricColorImg = null;
    this.uploadElRef.nativeElement.value = '';
    const element: HTMLElement = document.getElementById('uploaderFile') as HTMLElement;
    element.click();
  }
}
